const MarkerClusterer = require('@google/markerclustererplus');
const markers = new Map();
const infoWindows = new Map();
let locations
let visibleLocations
let map
let googlemapsConfig
let markerClusterer

function init(mapNode, store) {
	const state = store.getState()
	googlemapsConfig = state.config.googlemaps

	window.initMap = function () {
		map = new window.google.maps.Map(mapNode, googlemapsConfig.mapOptions);
		store.dispatch({type: 'mapInitialized'})
	}
	store.subscribe(() => onStateChange(store))
	includeGoogleScript(googlemapsConfig.apiKey)
}

function onStateChange(store) {
	const state = store.getState()
	const config = state.config
	if(!state.locationsLoaded || !state.mapInitialized) {
		return
	}

	if(state.locations === locations && state.visibleLocations === visibleLocations) {
		return;
	}
	let visibleMarkers = []

	if(state.locations != locations) {
		locations = state.locations
		visibleLocations = state.visibleLocations;
		[...locations].map(addMarker.bind(null, googlemapsConfig.marker, config.lang))
		visibleMarkers = [...markers.values()];
	}

	if(state.visibleLocations !== visibleLocations) {
		visibleLocations = state.visibleLocations

		for(let [location, marker] of markers.entries()) {
			if(visibleLocations.has(location))  {
				visibleMarkers.push(marker)
			}
		}
	}
	const clusterConfig = {
		...googlemapsConfig.cluster,
		title: config.labels['click-to-show']
	}

	addCluster(map, visibleMarkers, clusterConfig)
}

function addMarker(markerConfig, language, location) {
	const markerOptions = {
		map: map,
		position: new google.maps.LatLng(location.latitude, location.longitude),
		label: {
			text: '1',
			color: markerConfig.label.color
		},
		title: location.company || location.first_name + ' ' + location.last_name,
		icon: {
			...markerConfig.icon,
			path: window.google.maps.SymbolPath.CIRCLE
		}
	}

	let marker = new window.google.maps.Marker(markerOptions)
	marker.location = location
	markers.set(location, marker);
	marker.addListener('click', onMarkerClick.bind(null, marker, language))
}

function addCluster(map, markers, clusterConfig) {
	if(markerClusterer) {
		markerClusterer.clearMarkers()
		markerClusterer.addMarkers(markers)
		// markerClusterer.repaint()
	} else {
		markerClusterer = new MarkerClusterer(map, markers, clusterConfig);
	}
}

function includeGoogleScript(apiKey) {
	var scriptTag = document.createElement('script');
	scriptTag.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&callback=initMap')
	scriptTag.setAttribute('async', 'true')
	scriptTag.setAttribute('defer', 'true')
	document.body.appendChild(scriptTag);
}


function onMarkerClick(marker, language) {
	const infowindow = infoWindows.get(marker)  || new google.maps.InfoWindow({
		content: getInfoWindowContent(marker.location, language)
	});

	infoWindows.set(marker, infowindow)
	infowindow.open(map, marker)
}

function getInfoWindowContent(location, language) {
	let logo = location.logo ? `<div class="location-logo"><img src="${location.logo}"/></div>` : ''
	var tags = '';
    var json = location.seals_json || [];

	tags = json.map((element) => element['label'][language]).join(', ')

	return `<div class="location-info-window"><a target="_blank" href="${location.link}">
	${logo}
	<div class="location-infotext">
		<div class="location-title">${escapeHtml(location.company)}</div>
		<div class="location-location">${escapeHtml(location.city)}</div>
		<hr />
		<div class="location-tags">${escapeHtml(tags)}</div>
	</div>
	</a></div>`
}

// Escape a string for HTML interpolation.
function escapeHtml(string) {
	// List of HTML entities for escaping.
	var htmlEscapes = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		"'": '&#x27;',
		'/': '&#x2F;'
	};

	// Regex containing the keys listed immediately above.
	var htmlEscaper = /[&<>"'\/]/g;

	// Escape a string for HTML interpolation.
	return ('' + string).replace(htmlEscaper, function(match) {
		return htmlEscapes[match];
	});
};

module.exports = {
	init
}
